/* eslint-disable no-param-reassign */
import produce from 'immer';
var userLoadFailed = produce(function (draft, action) {
  var error = action.payload.error;
  draft.error = error;
});
export default userLoadFailed;